import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { container } from 'op/container';
import { compose, withProps, withState, withHandlers, lifecycle } from 'recompose';

import { withAxios } from 'op/components/auth';
import { withLanguageID } from 'op/components/locale';
import { withReadyLoader } from 'op/components/loader';
import { withErrorHandling } from 'op/components/error';
import url from "url";
import {clear_partial_reports} from "../../../redux/reducers/actions";


export const withReportSelection = compose(
  withAxios,
  withErrorHandling,
  withLanguageID,
  connect((state, { match: { params: { report_id, person_id } } }) => ({
    report: state.reports.loaded.find(report => report.id.toString() === report_id),
    person: state.person.loaded.find(person => person.id.toString() === person_id),
  }), (dispatch) => ({
    populateReport: (report) => dispatch(container.resolve('actions').add_reports([report])),
    navigateBack: () => dispatch(goBack()),
  })),
 
  withHandlers({
    fetchReport: ({ person, axios, match, empty, navigateBack, language, throwError, addPartialReport, populateReport }) => async () => {
      try {
        const { report_id, person_id } = match.params;

        const { data } = await axios.get(url.format({
          pathname: '/api/tasks/training_person_event_details',
          query: { person_id:person.person_id, report_id, language }
        }));

        const [rawReport] = data;

        if(rawReport && !rawReport.taskInfo) {
          throwError({ message: "Report Unavailable", details: "Report may have been deleted" });
          return navigateBack();
        } else {
          const report = container.resolve('transformers').report(rawReport.taskInfo);
          report.evaluations = rawReport.taskEvaluation.map(container.resolve('transformers').evaluation);
          report.attachments = rawReport.taskAttachment.map(container.resolve('transformers').attachment);

          populateReport({ ...report, partial: false });
        }
      } catch (e) {
        throwError({ 
          message: `Error fetching report ${match.params.report_id} for person ${match.params.person_id}`,
          details: `
            ${e.message};
            ${e.stack}
          `,
        });
      }
    }
  }),
  withProps(({ person, report }) => ({
    ready: (person && report && !report.partial),
  })),
  lifecycle({
    componentDidMount() {
      if(this.props.online){
        this.props.fetchReport()
      }
    }
  }),
  withReadyLoader,
);

export default {
  withReportSelection,
};